import { render, staticRenderFns } from "./ChatPanel.vue?vue&type=template&id=e4a4bf44&scoped=true&"
import script from "./ChatPanel.vue?vue&type=script&lang=js&"
export * from "./ChatPanel.vue?vue&type=script&lang=js&"
import style0 from "./ChatPanel.vue?vue&type=style&index=0&id=e4a4bf44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a4bf44",
  null
  
)

export default component.exports